import * as Three from 'three';
import React from 'react';

const DEPTH = 10;

function lineBreakWord(word, maxLength, numberOfLines) {
    let retunedArr = [];
    let splitWord = word.split(' ');

    retunedArr = splitWord.reduce((prev, curr) => {
        if (prev.length === 0) {
            prev.push(curr);
        }
        else {
            if (prev[prev.length - 1].length + curr.length <= maxLength) {
                prev[prev.length - 1] += ' ' + curr;
            }
            else {
                if (!numberOfLines || (numberOfLines && numberOfLines > prev.length))
                    prev.push(curr);
            }
        }

        return prev;
    }, [])

    return retunedArr;
}


export default {
    name: "steel-radiator",
    prototype: "items",

    info: {
        tag: ['metal'],
        title: "Steel radiator",
        description: "Steel radiator",
        image: require('./steel-radiator.png')
    },

    properties: {
        width: {
            label: "width",
            type: "length-measure",
            defaultValue: {
                length: 100,
                unit: 'cm'
            }
        },
        // height: {
        //     label: "height",
        //     type: "length-measure",
        //     defaultValue: {
        //         length: 100,
        //         unit: 'cm'
        //     }
        // },
        altitude: {
            label: "altitude",
            type: "length-measure",
            defaultValue: {
                length: 20,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {

        let WIDTH = element.properties.get('width') ? element.properties.get('width').get('length') : 100;
        let angle = element.rotation + 90;

        let textRotation = 0;

        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let desc = lineBreakWord(element.desc, 20);

        let rect_style = { stroke: 'red', strokeWidth: element.selecter ? '3px' : "2px", fill: "white" };

        return (
            <g transform={`translate(${-WIDTH / 2},${-DEPTH / 2})`}>
                <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH} style={rect_style} />
                <text key="8" x="0" y="0"
                    transform={`translate(${WIDTH / 2}, ${textRotation === 0 ? -5 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {

        let WIDTH = 100; //element.properties.get('width').get('length');
        let angle = element.rotation + 90;

        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let desc = lineBreakWord(element.desc, 20);

        let style = { stroke: 'red', strokeWidth: element.selecter ? '3px' : "2px", fill: "white" }
        let styleRight = { stroke: 'red', strokeWidth: element.selecter ? '3px' : "2px", fill: "#ccc" }
        let styleFront = { stroke: 'red', strokeWidth: element.selecter ? '3px' : "2px", fill: "#eee" }

        if (element.rotation === 0) {
            return (
                <g transform={`translate(${-WIDTH / 2}, -120)`}>
                    <g transform={`translate(${-WIDTH / 2 + 22}, 0) skewX(30)`}>
                        <rect key="1" x="0" y="50" width={WIDTH} height={10} style={style} />
                    </g>
                    <g transform={`translate(0, -193) skewY(55)`}>
                        <rect key="2" x={WIDTH} y="50" width="7" height="50" style={styleRight} />
                    </g>
                    <rect key="3" x="0" y="0" width={WIDTH} height="50" style={styleFront} />

                    {element.productCount
                        ? <>
                            <path d={`M${WIDTH + 2} 20 L${WIDTH + 40} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${WIDTH + 40} 50 L${WIDTH + 60} 50`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${WIDTH + 60}`} cy="50" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${WIDTH + 60}`}
                                y="-50"
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${WIDTH / 2}, ${textRotation === 0 ? -5 : 15}) scale(1,-1) rotate(${textRotation})`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        } else {
            return (
                <g transform={`rotate(${-element.rotation}), translate(${-WIDTH / 2 + 25}, -160)`}>
                    <g transform={`translate(-10, 0)`}>
                        <rect key="1" x="0" y="0" width={10} height={50} style={styleFront} />
                    </g>
                    <g transform={`translate(-40, 0) skewX(31)`}>
                        <rect key="2" x="0" y="50" width="10" height={WIDTH + 22} style={style} />
                    </g>
                    <g transform={`skewY(59)`}>
                        <rect key="3" x="0" y="0" width={WIDTH - 28} height="50" style={styleRight} />
                    </g>

                    {element.productCount
                        ? <>
                            <path d={`M40 80 L${WIDTH + 10} 120`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <path d={`M${WIDTH + 10} 120 L${WIDTH + 30} 120`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                            <circle id="3" cx={`${WIDTH + 30}`} cy="120" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                            <text
                                x={`${WIDTH + 30}`}
                                y="-120"
                                fontFamily="Arial"
                                alignmentBaseline="middle"
                                textAnchor="middle"
                                fontSize={24}
                                fill="#000000"
                                transform={`scale(1,-1) rotate(${textRotation})`}
                            >
                                {element.productCount}
                            </text>
                        </>
                        : <text key="8" x="0" y="0"
                            transform={`translate(${WIDTH / 2}, 70) scale(1,-1) rotate(-60)`}
                            style={{ textAnchor: "middle", fontSize: "11px" }}>
                            {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                        </text>}
                </g>
            )
        }
    },

};
